import { Paragraph } from "@smartsuite/react-ui/lib/components/typography/Paragraph/Paragraph";
import { Icon } from "@smartsuite/react-ui/lib/components/utils/Icon/Icon";
import { SolutionColorVariables } from "@smartsuite/types";
import type React from "react";

interface DuplicateDesignModalIconProps {
  label: string;
}

const iconDimension = {
  width: 59,
  height: 59,
};

export const DuplicateDesignModalIcon: React.FunctionComponent<
  DuplicateDesignModalIconProps
> = ({ label }) => {
  return (
    <div className="duplicate-design-icon">
      <div className="duplicate-design-icon__icon">
        <Icon
          size="M"
          name="layout-design"
          color={SolutionColorVariables.sc1}
          dimension={iconDimension}
        />
      </div>

      <div className="duplicate-design-icon__heading">
        <Paragraph size="m" weight="semibold" lineClamps={2}>
          {label}
        </Paragraph>
      </div>
    </div>
  );
};
